import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import styles from '../form.module.scss';

class SQFTFilter extends Component {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const { names, placeholders, tabIndex } = this.props;

    return (
      <Row>
        {names.map((name, i) => (
          <Col xs={6} key={i}>
            <InputGroup>
              <InputGroupAddon
                tag="label"
                htmlFor={name}
                addonType="prepend"
                className={styles.inlineInputGroupAddon}
              >
                <FontAwesome name="building" className={BS.inputGroupText} />
              </InputGroupAddon>
              <Input
                {...this.props[name].input}
                placeholder={placeholders[i] || 'None'}
                tabIndex={tabIndex !== undefined ? tabIndex + i : undefined}
                onChange={e => {
                  const val = e.target.value;
                  this.props[name].input.onChange(val !== '' ? parseInt(val, 0) : val);
                }}
              />
            </InputGroup>
          </Col>
        ))}
      </Row>
    );
  }
}

SQFTFilter.defaultProps = {
  names: ['minSqft', 'maxSqft'],
  placeholders: ['No Min', 'No Max']
};

export default SQFTFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/sqft-filter.js